import type { SxProps } from '@mui/material';
import React from 'react';

import { useGoToActiveCompetition } from '@/competitions/_common/hooks/useGoToActiveCompetition.ts';
import type { CompetitionWithConfig } from '@/lib/api/requests.ts';
import { mergeSx } from '@/lib/utils.ts';
import { Button } from '@/ui/Button.tsx';

import useBrainSession from '../../../../../../services/BrainSession/useBrainSession.ts';

import { useHasEnded } from './useHasEnded.ts';

export type CTAProps = {
  sx?: SxProps;
  onClick?: () => void;
  activeCompetition: CompetitionWithConfig | undefined;
};

export const CTA: React.FC<CTAProps> = ({ sx, onClick, activeCompetition }) => {
  const { toggleChat } = useBrainSession();
  const ended = useHasEnded();
  const goToActiveCompetition = useGoToActiveCompetition(activeCompetition);

  if (ended) {
    return (
      <Button
        color="orange"
        sx={mergeSx({ mx: 'auto' }, sx)}
        onClick={() => {
          onClick?.();
          void goToActiveCompetition();
        }}
      >
        Se den nye trekningen
      </Button>
    );
  }

  return (
    <Button
      color="orange"
      sx={mergeSx({ mx: 'auto' }, sx)}
      onClick={() => {
        onClick?.();
        toggleChat({
          goal: 'february_2025_campaign',
          step: 'init',
        });
      }}
    >
      Sjekk min gjeld og delta
    </Button>
  );
};
